module.exports = __webpack_public_path__ + "static/media/20.528421da.mp3";